import type { FormNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { Bold, Times, Within, SubFilters } from '../condition-parts';

export function FormCondition({ node }: { node: FormNode }) {
  const operator = node.inverse ? 'not submitted' : 'submitted';
  return (
    <ConditionCard node={node}>
      <Bold>{node.formName ?? 'form'}</Bold> {operator}
      <Times times={node.times} />
      <Within within={node.within} />
      <SubFilters filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionCard>
  );
}
